class MCartPromoBar extends HTMLElement {
  constructor() {
    super();
    this.cartTotal = parseFloat(this.dataset.cartTotal) || 0;
    this.cartItemCount = parseInt(this.dataset.cartItemCount, 10) || 0;
    this.freteThreshold = parseFloat(this.dataset.freteThreshold) || 180;
    this.brindeThreshold = parseFloat(this.dataset.brindeThreshold) || 229;
    this.isUpdating = false;
    this.init();
  }

  init() {
    this.updateProgress();
    this.listenForCartUpdates();
    this.observeCartChanges();
  }

  updateProgress() {
    var freteProgress = Math.min((this.cartTotal / this.freteThreshold) * 100, 100);
    var brindeProgress = Math.min((this.cartTotal / this.brindeThreshold) * 100, 100);

    var barFreteFill = this.querySelector('[data-bar-frete] .m-cart-promo-bar__bar-fill');
    if (barFreteFill) barFreteFill.style.width = freteProgress + '%';

    var barBrindeFill = this.querySelector('[data-bar-brinde] .m-cart-promo-bar__bar-fill');
    if (barBrindeFill) barBrindeFill.style.width = brindeProgress + '%';

    this.style.display = this.cartItemCount > 0 ? 'block' : 'none';
  }

  listenForCartUpdates() {
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, (cartData) => {
        if (cartData && cartData.total_price !== undefined) {
          this.cartTotal = cartData.total_price / 100;
          if (typeof cartData.item_count === 'number') this.cartItemCount = cartData.item_count;
          this.updateProgress();
        }
      });
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, () => {
        setTimeout(() => this.updateCartTotal(), 300);
      });
    }

    document.addEventListener('cart:updated', (event) => {
      if (event.detail && event.detail.cart) {
        this.cartTotal = event.detail.cart.total_price / 100;
        if (typeof event.detail.cart.item_count === 'number') this.cartItemCount = event.detail.cart.item_count;
        this.updateProgress();
      }
    });

    document.addEventListener('DOMContentLoaded', () => {
      const cartDrawer = document.querySelector('m-cart-drawer');
      if (cartDrawer) {
        const observer = new MutationObserver(() => setTimeout(() => this.updateCartTotal(), 100));
        observer.observe(cartDrawer, { childList: true, subtree: true });
        const cartDrawerObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              if (cartDrawer.classList.contains('m-cart-drawer--active')) {
                setTimeout(() => this.updateCartTotal(), 300);
              }
            }
          });
        });
        cartDrawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
      }
    });

    document.addEventListener('change', (event) => {
      if (event.target.matches('input[data-index]')) {
        setTimeout(() => this.updateCartTotal(), 500);
      }
    });
  }

  observeCartChanges() {
    const cartTotalElement = document.querySelector('[data-cart-subtotal-price]');
    if (cartTotalElement) {
      const observer = new MutationObserver(() => {
        const totalText = cartTotalElement.textContent || '';
        const totalMatch = totalText.match(/[\d,]+\.?\d*/);
        if (totalMatch) {
          const newTotal = parseFloat(totalMatch[0].replace(/,/g, ''));
          if (!isNaN(newTotal) && newTotal !== this.cartTotal) {
            this.cartTotal = newTotal;
            this.updateProgress();
          }
        }
      });
      observer.observe(cartTotalElement, { childList: true, characterData: true, subtree: true });
    }

    document.querySelectorAll('.m-cart-count-bubble').forEach(element => {
      const observer = new MutationObserver(() => {
        const itemCount = parseInt(element.textContent) || 0;
        if (itemCount === 0) { this.cartTotal = 0; this.cartItemCount = 0; this.updateProgress(); }
        else if (itemCount !== this.cartItemCount) { this.cartItemCount = itemCount; this.updateProgress(); }
      });
      observer.observe(element, { childList: true, characterData: true });
    });
  }

  updateCartTotal() {
    if (this.isUpdating) return;
    this.isUpdating = true;
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const newTotal = cart.total_price / 100;
        const newCount = typeof cart.item_count === 'number' ? cart.item_count : 0;
        if (newTotal !== this.cartTotal || newCount !== this.cartItemCount) {
          this.cartTotal = newTotal;
          this.cartItemCount = newCount;
          this.updateProgress();
        }
      })
      .catch(e => console.error(e))
      .finally(() => { this.isUpdating = false; });
  }
}

// ===== TIMER ATÉ MEIA NOITE =====
(function() {
  function pad(n) { return String(n).padStart(2, '0'); }
  function updateTimer() {
    var el = document.getElementById('promoTimerCountdown');
    if (!el) return;
    var now = new Date();
    var midnight = new Date(); midnight.setHours(24, 0, 0, 0);
    var total = Math.max(Math.floor((midnight - now) / 1000), 0);
    el.textContent = pad(Math.floor(total / 3600)) + ':' + pad(Math.floor((total % 3600) / 60)) + ':' + pad(total % 60);
  }
  updateTimer();
  setInterval(updateTimer, 1000);
})();

// ===== HINTS DINÂMICAS =====
(function() {
  function getConfig() {
    var bar = document.querySelector('[data-cart-promo-bar]');
    if (!bar) return null;
    return {
      freteThreshold: parseFloat(bar.dataset.freteThreshold) || 180,
      brindeThreshold: parseFloat(bar.dataset.brindeThreshold) || 229,
      freteEnabled: bar.dataset.freteEnabled !== 'false',
      msgFreteRestante: bar.dataset.msgFreteRestante || '🚚 Adicione mais {{ amount }} para ativar o Frete Grátis',
      msgFreteAtingido: bar.dataset.msgFreteAtingido || '✅ Você ativou o Frete Grátis!',
      msgBrindeRestante: bar.dataset.msgBrindeRestante || '🎁 Faltam {{ amount }} para você ganhar 1 Brinde Grátis!',
      msgBrindeAtingido: bar.dataset.msgBrindeAtingido || '🎉 Você ganhou 1 Brinde Grátis!'
    };
  }

  function formatMoney(value) {
    return 'R$ ' + value.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+,)/g, '$1.');
  }

  function buildMsg(template, amount) {
    return template.replace('{{ amount }}', '<strong>' + formatMoney(amount) + '</strong>');
  }

  function updatePromoBar(cart) {
    var config = getConfig();
    if (!config) return;

    var total = cart.total_price / 100;
    var itemCount = cart.item_count;
    var freteReached = total >= config.freteThreshold;
    var brindeReached = total >= config.brindeThreshold;
    var freteRemaining = Math.max(config.freteThreshold - total, 0);
    var brindeRemaining = Math.max(config.brindeThreshold - total, 0);
    var freteProgress = Math.min((total / config.freteThreshold) * 100, 100);
    var brindeProgress = Math.min((total / config.brindeThreshold) * 100, 100);

    var promoBar = document.querySelector('[data-cart-promo-bar]');
    if (promoBar) promoBar.style.display = itemCount > 0 ? 'block' : 'none';

    var barFreteFill = document.querySelector('[data-bar-frete] .m-cart-promo-bar__bar-fill');
    if (barFreteFill) barFreteFill.style.width = freteProgress + '%';

    var barBrindeFill = document.querySelector('[data-bar-brinde] .m-cart-promo-bar__bar-fill');
    if (barBrindeFill) barBrindeFill.style.width = brindeProgress + '%';

    if (config.freteEnabled) {
      var hintFrete = document.querySelector('[data-hint-frete]');
      if (hintFrete) {
        if (freteReached) {
          hintFrete.classList.add('is-reached');
          hintFrete.innerHTML = '<span>' + config.msgFreteAtingido + '</span>';
        } else {
          hintFrete.classList.remove('is-reached');
          hintFrete.innerHTML = '<span>' + buildMsg(config.msgFreteRestante, freteRemaining) + '</span>';
        }
      }
    }

    var hintBrinde = document.querySelector('[data-hint-brinde]');
    if (hintBrinde) {
      if (brindeReached) {
        hintBrinde.classList.add('is-reached');
        hintBrinde.innerHTML = '<span>' + config.msgBrindeAtingido + '</span>';
      } else {
        hintBrinde.classList.remove('is-reached');
        hintBrinde.innerHTML = '<span>' + buildMsg(config.msgBrindeRestante, brindeRemaining) + '</span>';
      }
    }
  }

  function syncPromoBar() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) { updatePromoBar(cart); }).catch(console.error);
  }

  document.addEventListener('DOMContentLoaded', syncPromoBar);
  document.addEventListener('cart:updated', syncPromoBar);
  document.addEventListener('minimog:cart:updated', syncPromoBar);
  setTimeout(syncPromoBar, 300);
  setTimeout(syncPromoBar, 800);
})();

customElements.define('m-cart-promo-bar', MCartPromoBar);
